export default __webpack_public_path__ + "static/media/cyberregW.762d35d2.png";